import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './css/SearchForm.css';
import {
  HOME_PAGE,
  TOUR_SEARCH_RESULT,
  HOTEL_DETAILS,
} from '../../Utils/Constants/GlobalConstants';
import {
  CHARTER_ONLY_PARAM,
  DIRECT_PARAM,
} from '../../Utils/Constants/urlParams';
import {
  changeCharterOnly,
  changeSelectedResorts,
  changeTouristsSearchText,
  changeDatesSearchText,
} from '../../DataStore/actions/searchFormActions';
import {
  changeSelectedHotels,
  changeIsAllRegionsFilterTab,
} from '../../DataStore/actions/FiltersAction';
import {
  getInitialSearchUrl,
  getInitialSearchUrlObj,
  getDateText,
  getNightsText,
  getTouristsText,
} from '../../Utils/CommonUtils';

import DesctopSearchFrom from './DesctopSearchForm/DesctopSearchFrom';
import TabletSearchForm from './TabletSearchForm/TabletSearchForm';

const mapStateToProps = (state) => ({ ...state });

class SearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSearchUrl = () => {
    const { onlyCharter, directFlight } = this.props;
    const queryParameters = getInitialSearchUrlObj(this.props);

    if (onlyCharter === 1) {
      queryParameters.append(CHARTER_ONLY_PARAM, 1);
    }

    if (directFlight === 1) {
      queryParameters.append(DIRECT_PARAM, 1);
    }

    return queryParameters.toString();
  };

  handleSubmit = () => {
    const {
      navigate,
      page,
      search,
      departureDate,
      nightsFrom,
      nightsTo,
      adults,
      kids,
      hotelsFilter,
      changeSelectedHotels: changeSelectedHotelsAction,
      changeTouristsSearchText: changeTouristsSearchTextAction,
      changeDatesSearchText: changeDatesSearchTextActoin,
    } = this.props;

    if (page === HOME_PAGE) {
      const searchUrl = this.getSearchUrl();
      navigate(`/search?${searchUrl}`, { state: { location: HOME_PAGE } });
    } else if (page === TOUR_SEARCH_RESULT && search) {
      search();

      const searchUrl = this.getSearchUrl();
      navigate(`/search?${searchUrl}`, {
        state: { location: TOUR_SEARCH_RESULT },
      });
    } else if (page === HOTEL_DETAILS) {
      search();

      const searchUrl = getInitialSearchUrl(this.props, true);
      navigate(`/hotel?${searchUrl}`, { state: { location: HOTEL_DETAILS } });
    }

    changeTouristsSearchTextAction(getTouristsText(adults, kids.length));

    changeDatesSearchTextActoin(
      `${getDateText(departureDate)} / ${getNightsText(nightsFrom, nightsTo)}`,
    );

    changeSelectedHotelsAction(hotelsFilter);
  };

  render() {
    const { isDisabled, page, hotel } = this.props;

    return (
      <div>
        <div className="sf_desctop">
          <DesctopSearchFrom
            handleSubmit={this.handleSubmit}
            page={page}
            isDisabled={isDisabled}
            hotel={hotel}
          />
        </div>
        <div className="sf_tablet">
          <TabletSearchForm
            handleSubmit={this.handleSubmit}
            page={page}
            isDisabled={isDisabled}
            hotel={hotel}
          />
        </div>
      </div>
    );
  }
}

SearchForm.propTypes = {
  navigate: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  page: PropTypes.string.isRequired,
  search: PropTypes.func,
  departureDate: PropTypes.instanceOf(Object).isRequired,
  nightsFrom: PropTypes.number.isRequired,
  nightsTo: PropTypes.number.isRequired,
  adults: PropTypes.number.isRequired,
  kids: PropTypes.instanceOf(Object).isRequired,
  changeSelectedHotels: PropTypes.func.isRequired,
  changeTouristsSearchText: PropTypes.func.isRequired,
  changeDatesSearchText: PropTypes.func.isRequired,
  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
  hotel: PropTypes.string,
  onlyCharter: PropTypes.number.isRequired,
  directFlight: PropTypes.number.isRequired,
};

SearchForm.defaultProps = {
  isDisabled: false,
  search: null,
  hotel: '',
};

export default connect(mapStateToProps, {
  changeCharterOnly,
  changeSelectedHotels,
  changeSelectedResorts,
  changeIsAllRegionsFilterTab,
  changeTouristsSearchText,
  changeDatesSearchText,
})(SearchForm);
